export default __webpack_public_path__ + "static/media/avatarAmy.d1a5ab1d.png";